import React from "react";
import styled from "styled-components";
import { Close, Description, Title } from "@radix-ui/react-dialog";
import { Button, Theme } from "@literati/public-ui-shared-react";
import BookShuffleCardDialog, {
  BookShuffleCardDialogClassName,
} from "components/bookShuffle/BookShuffleCardDialog";
import {
  bookShuffleCardDialogDescriptionFontStyles,
  bookShuffleCardDialogLayoutStyles,
  bookShuffleCardDialogTitleFontStyles,
} from "components/bookShuffle/bookShuffleCardDialogStyles";

import analytics from "analytics";
import useBookShuffle from "components/bookShuffle/useBookShuffle";

/** This is the className that will be pre-pended to all of BookShuffleCardDialogSkip's inner component classNames */
export const BOOK_SHUFFLE_CARD_DIALOG_SKIP_CLASS_BASE =
  "book-shuffle-card-dialog-skip";

/** These are all of the internal classNames that are used within the BookShuffleCardDialogSkip component */
export const BookShuffleCardDialogSkipClassName = {
  BASE: BOOK_SHUFFLE_CARD_DIALOG_SKIP_CLASS_BASE,
} as const;

const StyledBookShuffleCardDialog = styled(BookShuffleCardDialog)`
  & .${BookShuffleCardDialogClassName.CONTENT} {
    ${bookShuffleCardDialogLayoutStyles}
  }
`;

const StyledTitle = styled(Title)`
  ${bookShuffleCardDialogTitleFontStyles}
`;

const StyledDescription = styled(Description)`
  margin: 0.75rem 0 0;
  ${bookShuffleCardDialogDescriptionFontStyles}
`;

const ButtonContainer = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
`;

const StyledButton = styled(Button)`
  margin: 1.5rem 0 0;
  font-size: 0.875rem;
`;

const YES_IM_SURE_LABEL = "Yes, I’m Sure";

const RETURN_TO_BOOK_SHUFFLE_LABEL = "Return to Book Shuffle";

export interface BookShuffleCardDialogSkipProps {
  className?: string;
}

export const BookShuffleCardDialogSkip = ({
  className = "",
}: BookShuffleCardDialogSkipProps) => {
  const { showSkipConfirm, setShowSkipConfirm, handleSkip } = useBookShuffle();

  const cls = BookShuffleCardDialogSkipClassName;
  const name = "your child’s";

  return (
    <Theme>
      <StyledBookShuffleCardDialog
        className={`${cls.BASE} ${className}`}
        open={showSkipConfirm}
      >
        <StyledTitle>Are you sure?</StyledTitle>
        <StyledDescription>
          Book shuffle will provide us with helpful information to curate {name}{" "}
          boxes for the best experience possible!
        </StyledDescription>
        <ButtonContainer>
          <Close asChild>
            <Button
              onClick={() => {
                handleSkip();
                analytics.trackAmplitudeClickEvent(YES_IM_SURE_LABEL);
              }}
              variant="secondary"
            >
              {YES_IM_SURE_LABEL}
            </Button>
          </Close>
          <Close asChild>
            <StyledButton
              onClick={() => {
                setShowSkipConfirm(false);
                analytics.trackAmplitudeClickEvent(
                  RETURN_TO_BOOK_SHUFFLE_LABEL
                );
              }}
              variant="link"
            >
              {RETURN_TO_BOOK_SHUFFLE_LABEL}
            </StyledButton>
          </Close>
        </ButtonContainer>
      </StyledBookShuffleCardDialog>
    </Theme>
  );
};

export default BookShuffleCardDialogSkip;
